module.exports = __webpack_public_path__ + "static/img/ditie.2aec138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/ditie.png
// module id = KTSd
// module chunks = 1